import React, { useState } from 'react'
import { Box, Flex, Button } from 'rebass'
import Form from 'components/Form'
import Page from 'components/Page'
import Message from 'components/Message'
import * as model from 'models/accountPassword'

export default () => {
  const [disableSubmit, setDisableSubmit] = useState(false)

  return (
    <Page title="account.password.title">
      <Form {...model} actions={{ setDisableSubmit }}>
        {({ form, action, state }) => (
          <Box p={3}>
            {form.password}
            {form.newPassword}
            {form.newPasswordConfirm}
            <Flex justifyContent="flex-end" pt={2}>
              <Button disabled={disableSubmit} variant="accent">
                <Message id="btn.submit" />
              </Button>
            </Flex>
          </Box>
        )}
      </Form>
    </Page>
  )
}
